// extracted by mini-css-extract-plugin
export default {"assinatura":"assinatura_assinatura__OEiqC"};